import { z } from "zod";
import {
  CaptureResponseSchema,
  DecisionSchema,
  SummarySchema,
  type CaptureInput,
  type CaptureResponse,
  type Decision,
  type Summary,
} from "@idea-studio/shared";

async function getJson<T>(url: string, schema: { parse: (v: unknown) => T }): Promise<T> {
  const res = await fetch(url, {
    headers: { accept: "application/json" },
    cache: "no-store",
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`${url} -> ${res.status}: ${text}`);
  }
  const json = await res.json();
  return schema.parse(json);
}

export async function getSummary(): Promise<Summary> {
  return getJson("/api/state/summary", SummarySchema);
}

export async function postCapture(input: CaptureInput): Promise<CaptureResponse> {
  const res = await fetch("/api/capture", {
    method: "POST",
    headers: { "content-type": "application/json", accept: "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`POST /api/capture -> ${res.status}: ${text}`);
  }
  return CaptureResponseSchema.parse(await res.json());
}

const RecentDecisionsResponseSchema = z.object({
  decisions: z.array(DecisionSchema),
  fetched_at: z.string(),
});

export async function getRecentDecisions(limit = 10): Promise<Decision[]> {
  const res = await getJson(
    `/api/decisions/recent?limit=${limit}`,
    RecentDecisionsResponseSchema,
  );
  return res.decisions;
}
